import { Layout as ALayout } from "antd"
import { Toolbar } from "../../../shared"
import { Subheader } from "../subheader"
import PropTypes from "prop-types"

Layout.propTypes = {
  children: PropTypes.node,
  fullHeight: PropTypes.bool
}

export function Layout ({ children, fullHeight }) {
  const subheader = ({ title, actions, currentStepKey, stepsToOmit }) => {
    return <Subheader
      title={title}
      actions={actions}
      stepsToOmit={stepsToOmit}
      currentStepKey={currentStepKey} />
  }

  const className = fullHeight ? "full-height" : null

  return (
    <div className="fico layout submissions full-height">
      <ALayout className={className}>
        <ALayout.Content>
          <Toolbar subheader={subheader} />
          <div className="page-content">
            {children}
          </div>
        </ALayout.Content>
      </ALayout>
    </div>
  )
}
